import { render, staticRenderFns } from "./l-keys-list-view.vue?vue&type=template&id=53527b32&scoped=true"
import script from "./l-keys-list-view.vue?vue&type=script&lang=js"
export * from "./l-keys-list-view.vue?vue&type=script&lang=js"
import style0 from "./l-keys-list-view.vue?vue&type=style&index=0&id=53527b32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53527b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53527b32')) {
      api.createRecord('53527b32', component.options)
    } else {
      api.reload('53527b32', component.options)
    }
    module.hot.accept("./l-keys-list-view.vue?vue&type=template&id=53527b32&scoped=true", function () {
      api.rerender('53527b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mlocalization/views/l-keys-list-view.vue"
export default component.exports